import i18n from "@/i18n";

const LANGUAGE_CACHE_KEY = "language";

const state = {
  language: localStorage.getItem(LANGUAGE_CACHE_KEY) || "zh",
  temporaryLanguage: "en", // 临时语言，不做持久化
};

const getters = {
  getLanguage: state => state.language,
  getTemporaryLanguage: state => state.temporaryLanguage,
};

const mutations = {
  SET_LANGUAGE(state, language) {
    state.language = language;
    // 同步修改i18n的语言设置
    i18n.locale = language;
    // 持久化
    localStorage.setItem(LANGUAGE_CACHE_KEY, language);
  },
  SET_TEMPORARY_LANGUAGE(state, language) {
    state.temporaryLanguage = language || "en";
    // 同步修改i18n的语言设置
    i18n.locale = language;
  },
};

const actions = {
  // 切换语言
  switchLanguage({ commit }, language) {
    commit("SET_LANGUAGE", language);
  },
  // 切换临时语言
  switchTemporaryLanguage({ commit }, language) {
    commit("SET_TEMPORARY_LANGUAGE", language);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
